/**
 * Dynamic Yield Standard Events
 * @doc https://support.dynamicyield.com/hc/en-us/articles/360023172893-Events
 */
export enum DyMetrics {
  purchase = 'Purchase',
  add_to_cart = 'Add to Cart',
  application = 'Application',
  submission = 'Submission',
  remove_form_cart = 'Remove from Cart',
  sync_cart = 'Sync Cart',
  add_to_wishlist = 'Add to Wishlist',
  login = 'Login',
  signup = 'Signup',
  identify_user = 'Identify User',
  newsletter_subscription = 'Newsletter Subscription',
  message_opt_in = 'Message Opt-in',
  message_opt_out = 'Message Opt-out',
  keyword_search = 'Keyword Search',
  filter_items = 'Filter Items',
  sort_items = 'Sort Items',
  change_attribute = 'Change Attribute',
  promo_code_entered = 'Promo Code Entered',
  video_watch = 'Video Watch',
}
